/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import Modal from 'components/UI/Modal';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';

const maxWidth = 512;

const FeedbackWithEditableBtn = ({
  getFeedbackDisplay,
  ContinueBtn,
  onClose,
}: {
  getFeedbackDisplay?: any;
  ContinueBtn?: any;
  onClose?: any;
}) => {
  const parsedOnClose = () => {
    window.dev() && checkReturnToInteractionEditing(true);
    onClose();
  };
  //
  return (
    <Modal onClose={parsedOnClose}>
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 100%;
          max-width: 768px;
          padding: 50px;
        `}
      >
        <div
          css={css`
            width: 75%;
            max-width: ${maxWidth * 0.75}px;
            margin-bottom: 30px;

            @media (max-width: 768px) {
              width: 100%;
              margin-bottom: 25px;
            }
          `}
        >
          {getFeedbackDisplay().props.children[0]}
        </div>
        <div
          css={css`
            width: 100%;
            margin-bottom: 30px;
          `}
        >
          {getFeedbackDisplay().props.children[1]}
        </div>
        <div
          css={css`
            display: flex;
            justify-self: flex-end;
            justify-content: center;
            width: 100%;
          `}
        >

          <span onClick={() => (!window.dev() ? parsedOnClose() : null)}>
            {ContinueBtn}
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default FeedbackWithEditableBtn;
